const helperFunction = {
  convertDate: (date) => {
    date = date.split("-");

    var newDate = new Date(date[0], date[1] - 1, date[2]);

    return newDate.getTime();
  },
  convertEndDate: (date) => {
    date = date.split("-");

    var newDate = new Date(date[0], date[1] - 1, date[2], 23, 59, 59);
    newDate.setMilliseconds(999);

    return newDate.getTime();
  },
  capitalizeAndReplaceSpace: (char, type) => {
    let tempChar = char.split(type).join(" ");
    return tempChar.charAt(0).toUpperCase() + tempChar.slice(1);
  },

  stringGenerator: (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  stdToken: () => {
    let rStr = {
      randomString: (chars, length) => {
        let result = "";
        const charactersLength = chars.length;
        for (let i = 0; i < length; i++) {
          result += chars.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      },
    };
    return (
      "S2D" +
      "-" +
      rStr.randomString("0123456789", 13) +
      "-" +
      rStr.randomString("ABCDEFGHIJKLMNOPQRSTUVWXYZ", 2)
    );
  },
  toCamelCase: (str) => {
    return str
      .replace(/\s(.)/g, function ($1) {
        return $1.toUpperCase();
      })
      .replace(/\s/g, "")
      .replace(/^(.)/, function ($1) {
        return $1.toLowerCase();
      });
  },
  calculateItem: (itemDimension, type) => {
    let length = Number(itemDimension.length),
      width = Number(itemDimension.width),
      height = Number(itemDimension.height);

    if (type != "cartonPacking") {
      length = length / 100; // Converting into metre
      width = width / 100; // Converting into metre
      height = height / 100; // Converting into metre
    }

    const value = {
      cartonPacking: () => {
        return (length * width * height) / 1000000;
      },
      palletPacking: () => {
        return 2 * (length * width);
      },
      cratePacking: () => {
        return (
          2 * (length * width) + 2 * (height * width) + 2 * (length * height)
        );
      },
      woodenPacking: () => {
        return (
          2 * (length * width) + 2 * (height * width) + 2 * (length * height)
        );
      },
    };

    return value[type]();
  },
  dimensionAfterPacking: (itemDimension, type) => {
    const length = Number(itemDimension.length),
      width = Number(itemDimension.width),
      height = Number(itemDimension.height);

    const cartonAfterPacking = { length: 1, width: 1, height: 1 },
      palletAfterPacking = { length: 1, width: 1, height: 15 },
      createAfterPacking = { length: 6, width: 6, height: 15 },
      woodenAfterPacking = { length: 6, width: 6, height: 15 };

    const value = {
      cartonPacking: () => {
        return {
          length: length + cartonAfterPacking.length,
          width: width + cartonAfterPacking.width,
          height: height + cartonAfterPacking.height,
        };
      },
      palletPacking: () => {
        return {
          length: length + palletAfterPacking.length,
          width: width + palletAfterPacking.width,
          height: height + palletAfterPacking.height,
        };
      },
      cratePacking: () => {
        return {
          length: length + createAfterPacking.length,
          width: width + createAfterPacking.width,
          height: height + createAfterPacking.height,
        };
      },
      woodenPacking: () => {
        return {
          length: length + woodenAfterPacking.length,
          width: width + woodenAfterPacking.width,
          height: height + woodenAfterPacking.height,
        };
      },
    };

    return value[type]();
  },
  calculateVolume: (dim) => {
    return (dim.length * dim.width * dim.height) / 1000000;
  },
  calculateWeight: (weight, diff, type) => {
    const itemWeight = Number(weight);
    const difference = Number(diff).toFixed(3);
    let wght = 0;

    let getWeight = (dif, val, incrementBy) => {
      let dVal = dif.toString().split(".");
      let valA = Number(dVal[0]);
      let valB = parseFloat(`0.${dVal[1]}`);
      if (valA > 0) {
        wght = valA / val;
      }
      if (valB <= val) {
        wght += incrementBy;
      } else {
        let secDiv = valB / val;
        let dValOne = secDiv.toString().split(".");
        let valC = Number(dValOne[0]);
        let valD = parseFloat(`0.${dValOne[1]}`);
        wght += valC;
        getWeight(valD, val, incrementBy);
      }
      return wght;
    };

    const value = {
      cartonPacking: () => {
        let gWght = getWeight(difference, 0.25, 1); // (difference, min Value, increment By)
        return (gWght + itemWeight).toFixed(3);
      },
      palletPacking: () => {
        let gWght = getWeight(difference, 0.25, 8); // (difference, min Value, increment By)
        return (gWght + itemWeight).toFixed(3);
        // return (((difference / 0.25) * 8) + itemWeight).toFixed(3)
      },
      cratePacking: () => {
        return (difference * 2 * 6 + itemWeight).toFixed(3);
      },
      woodenPacking: () => {
        return (difference * 2.6 * 6 + itemWeight).toFixed(3);
      },
    };

    return value[type]();
  },
  calculatePrice: (volume, noOfPck, type) => {
    const itemVol = Number(volume);
    const cartonFreight = { perUnit: 100, minimum: 100 };
    const palletFreight = { perUnit: 50, minimum: 75 };
    const crateFreight = { perUnit: 50, minimum: 150 };
    const woodenFreight = { perUnit: 50, minimum: 150 };

    const calculateFrieght = (perUnit, minimum) => {
      let freight = itemVol * perUnit;
      freight = freight < minimum ? minimum : freight;
      return freight * Number(noOfPck);
    };

    const value = {
      cartonPacking: () => {
        return calculateFrieght(cartonFreight.perUnit, cartonFreight.minimum);
      },
      palletPacking: () => {
        return calculateFrieght(palletFreight.perUnit, palletFreight.minimum);
      },
      cratePacking: () => {
        return calculateFrieght(crateFreight.perUnit, crateFreight.minimum);
      },
      woodenPacking: () => {
        return calculateFrieght(woodenFreight.perUnit, woodenFreight.minimum);
      },
    };

    return value[type]();
  },
  calculateInsurancePer: (insurancePer, freight, insuranceAmt) => {
    const minValue = 150;
    let finalAmt =
      ((Number(freight) + Number(insuranceAmt)) * Number(insurancePer)) / 100;

    return finalAmt > minValue ? finalAmt : minValue;
  },

  calculateStorage: (noOfDay, storageRate, volume, handlingIn, handlingOut) => {
    const minValue = 100;
    let finalAmt =
      Number(noOfDay) * Number(storageRate) +
      Number(handlingIn) * Number(volume) +
      Number(handlingOut) * Number(volume);

    return finalAmt > minValue ? finalAmt : minValue;
    // (no of day * storage rate) + handling in * volume + handling out * volume
  },
  handleDecimalPoints: (val, digit, withFixed) => {
    if (String(val).includes(".")) {
      if(withFixed){
        return Number(val).toFixed(digit)
      }else{
        let newVal = String(val).split(".");
        newVal[1] = newVal[1].slice(0, digit);
        return Number(newVal.join("."));
      }
    } else {
      return val;
    }
  },
  convertToSelectList: (arr, label, value) => {
    return arr.map((item) => {
      return { label: item[label], value: item[value], isoCode: item.isoCode };
    });
  },

  accessArrayCreater: (arr, access) => {
    let data = JSON.parse(JSON.stringify(access)).filter((item) => {
      if (item.sub_item) {
        let subindata = item.sub_item.filter((item3) => {
          if (item3.sub_item) {
            let subfilter = item3.sub_item.filter((item4) => {
              let checkId2 = arr.find((e) => {
                return (
                  e?.item_id.slice(0, 3) ==
                  item4.item_id.slice(0, 3)
                );
              });
              if (checkId2) {
                return item4;
              }
            });
            if (subfilter && subfilter.length > 0) {
              item3.sub_item = subfilter;
              return item3;
            }
          } else {
            let checkId1 = arr.find((e) => {
              return (
                e?.item_id.slice(0, 2) ==
                item3.item_id.slice(0, 2)
              );
            });

            if (checkId1) {
              return item3;
            }
          }
        });

        let FindId = arr.find((el) => {
          return el.item_id.toString()[0] == item.item_id.toString()[0];
        });

        if (FindId) {
          item.sub_item = subindata;
          return item;
        }
      } else {
        let checkId = arr.find((e) => {
          return e?.item_id?.toString()[0] == item?.item_id?.toString()[0];
        });
        if (checkId) {
          return item;
        }
      }
    });
    return data;
  },

  accessArrayCreater1: (arr, access) => {
    let newData2 = []
    let data = JSON.parse(JSON.stringify(access)).filter((item) => {
      if (item.sub_item) {
        let newData1 = []
        let subindata = item.sub_item.filter((item3) => {
          if (item3.sub_item) {
            let newData = []
            let subfilter = item3.sub_item.filter((item4) => {
              let checkId2 = arr.find((e) => {
                return (
                  e.item_id.toString().slice(0, 3) ==
                  item4.item_id.toString().slice(0, 3)
                );
              });
              if (checkId2) {
                newData.push({ ...item4, permissions: checkId2.permissions })
                return { ...item4, permissions: checkId2.permissions };
              }
            });

            if (newData && newData.length > 0) {
              // item3.sub_item = subfilter;
              newData1.push( { ...item3, sub_item: newData })
              return { ...item3, sub_item: newData };
            }
          } else {
            let checkId1 = arr.find((e) => {
              return (
                e.item_id.toString().slice(0, 2) ==
                item3.item_id.toString().slice(0, 2)
              );
            });

            if (checkId1) {
              newData1.push( { ...item3, permissions: checkId1.permissions })
              return { ...item3, permissions: checkId1.permissions };
            }
          }
        });

        let FindId = arr.find((el) => {
          return el.item_id.toString()[0] == item.item_id.toString()[0];
        });

        if (FindId) {
          newData2.push({ ...item, sub_item : newData1})
          item.sub_item = newData1;
          return item;
        }
      } else {
        let checkId = arr.find((e) => {
          return e.item_id.toString()[0] == item.item_id.toString()[0];
        });
        if (checkId) {
          newData2.push({ ...item,permissions: checkId.permissions})
          return { ...item, permissions: checkId.permissions };
        }
      }
    });
    return newData2;
  },
  // fixedDesimalNumber(num) {
  //   return num.toString().slice(0, num.toString().indexOf('.') + 4);
  // },
  
  fixedDesimalNumber(num) {
    let strNum = num.toString();
    let decimalIndex = strNum.indexOf('.');

    if (decimalIndex === -1) {
        return strNum; // No decimal point, return as is
    }

    return strNum.slice(0, decimalIndex + 4); // Keep up to 3 decimal places
}

};

export default helperFunction;
